import { useQuery } from "@tanstack/react-query";
import { getAllStudents } from "../../api/apiStudents";
import i18next from "i18next";
export function useGetStudents(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({ queryKey: ["students", page, perPage, filters, i18next.language], queryFn: () => getAllStudents(page, perPage, filters), retry: false });
    return { isLoading, error, students: data?.data?.items || [], meta: data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 } };
}
